import { render, staticRenderFns } from "./share-post.vue?vue&type=template&id=4ed134dd&"
import script from "./share-post.vue?vue&type=script&lang=js&"
export * from "./share-post.vue?vue&type=script&lang=js&"
import style0 from "./share-post.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports